function IconPlus() {
  return (
    <svg viewBox="0 0 50 50">
      <path d="M24,33h0a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h0a9,9,0,0,1,9,9h0A9,9,0,0,1,24,33Zm5.92-2.08L34,35M21,24h6m-3-3v6" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
    </svg>
  );
}

export default IconPlus;
